import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from '../guards/auth.guard';
import { PreinscribirComponent } from './preinscribir/preinscribir.component';
import { RegistroAspiranteComponent } from './registro-aspirante/registro-aspirante.component';

const routes: Routes = [

    { path: 'register', component: RegisterComponent },
    { path: 'login', component: LoginComponent},
    { path: 'preinscribir', component: PreinscribirComponent},
    { path: 'registroaspirante/:curp', component: RegistroAspiranteComponent},

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule {}
